/**
 * @file
 * Expandable text tiles.
 */

(function textTileExpandable($, Drupal, _, window) {
  'use strict';

  // CSS Animation settings
  // Durations in ms.
  // These should match the css animations.
  // Expanding has 1 phase1.
  var EXPAND_01_DURATION = 400;
  // Collapsing has 2 phases.
  var COLLAPSE_01_DURATION = 400;
  var COLLAPSE_02_DURATION = 400;

  // JS animation settings.
  var EXPAND_SCROLL_TOP_BUFFER = 10;
  var EXPAND_SCROLL_ANIMATION_DURATION_DIRECT_LINK = 600;

  // Get the left tile of the given tile assuming a 2 column grid.
  var getLeftTile = function ($container) {
    var $prevContainers = $container.prevAll('.text-tile--expandable').filter(':not(.text-tile--expanded)');
    if ($prevContainers.length > 0 && ($prevContainers.length % 2) !== 0) {
      return $prevContainers.first();
    }

    return [];
  };

  /**
   * Process the expandable element.
   *
   * @param {Object} $container
   *   The text tile container jQuery object.
   * @param {string} operation
   *   The operation to perform: 'expand', 'collapse'.
   * @param {int} scrollDuration
   *   The duration for the scroll animation.
   *
   * @return {Object}
   *   The passed in container jQuery object.
   */
  var processExpandable = function ($container, operation, scrollDuration) {
    if ($container.length === 0) {
      return $container;
    }

    var $leftContainer = getLeftTile($container);
    if ($leftContainer !== null && $leftContainer.length > 0) {
      // Scroll processing.
      if (operation === 'collapse') {
        // Collapse.
        scrollCollapse($container, scrollDuration);
      }
      else {
        // Expand.
        $container.addClass('right-container');
        scrollExpand($container, scrollDuration);
      }
    }
    else if (operation === 'collapse') {
      // Collapse.
      collapse($container);
    }
    else {
      // Default: Expand.
      expand($container);
    }

    return $container;
  };

  // Collapse the expandable.
  var collapse = function ($container, scrollDuration) {
    $container.addClass('text-tile--collapsing');
    window.setTimeout(function () {
      $container.removeClass('text-tile--expanded text-tile--collapsing right-container');
      $container.animate({
        marginTop: 0
      }, COLLAPSE_02_DURATION);
    }, COLLAPSE_01_DURATION + COLLAPSE_02_DURATION);
  };

  // Expand the expandable.
  var expand = function ($container) {
    $container.addClass('text-tile--expanded');
  };

  // Collapse and scroll back up.
  var scrollCollapse = function ($container, scrollDuration) {
    // Scroll back up.
    var scrollTopOffset = $container.offset().top;
    if (scrollTopOffset > 0) {
      // Previous container adjust.
      var $leftContainer = getLeftTile($container);
      if ($leftContainer.length > 0) {
        scrollTopOffset -= $leftContainer.outerHeight();
      }

      // Adjust for sticky nav.
      var navHeight = $('.site__header > .navigation').outerHeight() || 0;
      scrollTopOffset -= 3 * navHeight;

      // Buffer.
      scrollTopOffset -= EXPAND_SCROLL_TOP_BUFFER;

      // Animate the scroll.
      if (scrollTopOffset > 0) {
        collapse($container, scrollDuration);
      }
      else {
        // Fallback.
        collapse($container, scrollDuration);
      }
    }
    else {
      // No scroll.
      collapse($container, scrollDuration);
    }
  };

  // Scroll and expand the expandable.
  var scrollExpand = function ($container, scrollDuration) {
    var scrollTopOffset = $container.offset().top;
    if (scrollTopOffset > 0) {
      // Previous container adjust.
      var $leftContainer = getLeftTile($container);
      if ($leftContainer.length > 0) {
        scrollTopOffset += $leftContainer.outerHeight();
      }

      // Adjust for sticky nav.
      var navHeight = $('.site__header > .navigation').outerHeight() || 0;
      scrollTopOffset -= 3 * navHeight;

      // Buffer.
      scrollTopOffset -= EXPAND_SCROLL_TOP_BUFFER;
      // Animate the scroll.
      if (scrollTopOffset > 0) {
        $($container).animate({
          marginTop: $container.outerHeight()
        }, {
          duration: EXPAND_01_DURATION,
          complete: function () {
            expand($container);
          }
        });
        $('html, body').animate({
          scrollTop: $container.offset().top - $container.outerHeight()
        }, {
          duration: EXPAND_01_DURATION
        });
      }
      else {
        // Fallback.
        expand($container);
      }
    }
    else {
      // No scroll.
      expand($container);
    }
  };

  /**
   * Expandable text tiles.
   */
  Drupal.behaviors.textTileExpandable = {
    attach: function (context) {
      $('.text-tile--expandable:not(.pin-expandable-processed)', context).each(function () {
        var $container = $(this);
        $container.addClass('pin-expandable-processed');
        var $expandable = $('> .text-tile__expandable-element', $container);

        // Skip if nothing to expand.
        if ($expandable.length === 0) {
          $('> .text-tile__cta', $container).hide(0);
          return true;
        }

        // Expand click listener.
        $('> .text-tile__cta .js-button--link', $container).click(function (event) {
          event.preventDefault();
          var $parentContainer = $(this).closest('.text-tile--expandable');
          if ($parentContainer.length > 0) {
            processExpandable($parentContainer, 'expand');
          }
        });

        // Collapse click listener.
        $('.expandable-element__header .js-button--link', $expandable).click(function (event) {
          event.preventDefault();
          var $parentContainer = $(this).closest('.text-tile--expandable');
          if ($parentContainer.length > 0) {
            processExpandable($parentContainer, 'collapse');
          }
        });
      });

      // Process incoming links.
      if (window.location.hash && window.location.hash.indexOf('=') === -1) {
        var $bodyInit = $('body:not(.pin-expandable-init-processed)', context);
        if ($bodyInit.length > 0) {
          $bodyInit.addClass('pin-expandable-init-processed');
          var $incomingTrigger = $(window.location.hash, $bodyInit)
            .filter('.text-tile__expandable-anchor-link')
            .siblings('.text-tile__cta')
            .find('> .js-button--link');
          if ($incomingTrigger.length > 0) {
            var $incomingContainer = $incomingTrigger.closest('.text-tile--expandable');
            if ($incomingContainer.length > 0) {
              scrollExpand($incomingContainer, EXPAND_SCROLL_ANIMATION_DURATION_DIRECT_LINK);
            }
          }
        }
      }
    }
  };

}(jQuery, Drupal, _, window));
